import $ from 'cash-dom';

export function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
};
export function formAutoFill(data) {
    let keys = Object.keys(data);
    // console.trace('call auto fill');
    // console.log('auto fill', data);
    for (let key of keys) {
        if (data[key]) {
            try {
                if (!(key == "email" && data[key].indexOf("@facebook.com") > -1)) {
                    $(`#modal-woay-userinfo .w-${key}`).val(data[key]);
                }
            } catch (err) {
                console.log(err);
            }
        }
    }
}

export function mergeNewAwardToList(_rewardData, data) {
    if (data) {
        if (!data.item_name) {
            data.item_name = data.name;
        }
        if (!data.updated_at) {
            data.updated_at = new Date();
        }
    }
    _rewardData.rewards.unshift(data);
    return _rewardData;
}


export function validateUserInfo(Wheel, data) {
    // console.log('validateUserInfo', data);
    let form = Wheel.form;
    let errorKeys = [];
    for (let key of Object.keys(form)) {
        // this field is required
        if (form[key].enabled && form[key].required) {
            if (!data[key]) {
                // console.log('is error', key);
                errorKeys.push(key);
            }
        }
    }
    return errorKeys;
}

export function checkErrorFactory(html, local, SETTINGS) {
    return function (error) {
        // console.trace('checkErrorFactory', error);
        var err = error;
        console.log('err', err);
        // console.trace(err);
        // Try to parse if error is a json-string
        if (typeof error === 'string') {
            try {
                var json = JSON.parse(error);
                err = json
            } catch (e) {}
        }

        if (err && err.error && err.error.message == "Hết lượt") {
            html.hideLoading();
            return;
        }
        if (err && err.error && err.error.message == 'code is invalid') {
            $('#w-play-code .w-verify_code').parent().addClass('error');
            $('#w-play-code .error .w-error-log').text('Mã chơi không chính xác');
            return;
        }

        if (err && err.error && err.error.message == 'wrong password') {
            console.log('wrong passwork sign in');
            $('#modal-woay-userinfo .w-password').parent().addClass('error');
            $('#modal-woay-userinfo .error .w-error-log').text('Mật khẩu không chính xác');
            html.hideLoading();
            return;
        }

        if (err && err.error && err.error.message == 'No item left') {
            html.closeAllModal('helper:85');
            html.hideLoading();
            setTimeout(function () {
                html.getModalNoItemLeft(SETTINGS)
            }, 200);
            return;
        }

        if (err && err.error && err.error.message == 'All items are out of stock') {
            html.closeAllModal('helper:94');
            html.hideLoading();
            setTimeout(function () {
                html.getModalOutOfStock(SETTINGS);
            }, 200);
            return;
        }

        if (err && err.error && err.error.message == 'Total win_rate = 0') {
            html.closeAllModal('helper:103');
            html.hideLoading();
            setTimeout(function () {
                html.getModalTotalWinRate(SETTINGS)
            }, 200);
            return;
        }

        if (err && err.error && err.error.message == 'player_game_id') {
            html.closeAllModal('helper:112');
            html.hideLoading();
            // localStorage.clear()
            setTimeout(function () {
                html.getModalErrorLogin(SETTINGS);
            }, 200);
            local.remove('userInfo');
            local.remove('wauth');
            return;
        }

        if (err && err.error && err.error.message == 'player_game') {
            html.closeAllModal('helper:112');
            html.hideLoading();
            // localStorage.clear()
            setTimeout(function () {
                html.getModalErrorLogin(SETTINGS);
            }, 200);
            local.remove('userInfo');
            local.remove('wauth');
            return;
        }
        if (err && err.error && err.error.message == 'Reward has been awarded') {
            html.hideLoading();
            console.log('ko show popup');
            return;
        }

        if (err && err.error && err.error.message == 'order' || err && err.error && err.error.message == 'Not Found') {
            html.closeAllModal('helper:112');
            html.hideLoading();
            setTimeout(function () {
                html.getModalHaravanOrder(SETTINGS)
            }, 200);
            return;
        }

        if (err && err.error && err.error.message == 'Validation failed: Phone must be a valid phone number and start with +84 character' || err && err.error && err.error.message == 'wrong phone number') {
            html.closeAllModal('helper:112');
            html.hideLoading();
            setTimeout(function () {
                html.getModalErrorPhone(SETTINGS)
            }, 200);
            return;
        }

        // Else
        html.closeAllModal('helper:121');
        html.hideLoading();
        setTimeout(function () {
            html.getModalUnknownError(SETTINGS);
        }, 200);
    }
}